import Vue from "vue";

import IconBlank from "@/components/IconBlank.vue";
Vue.component("icon-blank", IconBlank);

import VAspectRatioBox from "@/components/VAspectRatioBox.vue";
Vue.component("v-aspect-ratio-box", VAspectRatioBox);

import VDropdown from "@/components/VDropdown.vue";
Vue.component("v-dropdown", VDropdown);

import InputPhoneNumber from "@/components/InputPhoneNumber.vue";
Vue.component("input-phone-number", InputPhoneNumber);

import SwitchButton from "@/components/SwitchButton.vue";
Vue.component("switch-button", SwitchButton);

import InputNumber from "@/common/ui/components/VInputNumber.vue";
Vue.component("input-number", InputNumber);

import InputPostcode from "@/components/InputPostcode.vue";
Vue.component("input-postcode", InputPostcode);

import AppLocation from "@/components/AppLocation.vue";
Vue.component("app-location", AppLocation);

import VueInfiniteLoading from "vue-infinite-loading";
Vue.component("infinite-loading", VueInfiniteLoading);

import VButtonPrev from "@/components/VButtonPrev.vue";
Vue.component("v-button-prev", VButtonPrev);

import VButtonNext from "@/components/VButtonNext.vue";
Vue.component("v-button-next", VButtonNext);

import VLocationControl from "@/components/VLocationControl.vue";
Vue.component("v-location-control", VLocationControl);

import VButtonUpload from "@/components/VButtonUpload.vue";
Vue.component("v-button-upload", VButtonUpload);

import VGrid from "@/components/VGrid.vue";
import VGridCell from "@/components/VGridCell.vue";
Vue.component("v-grid", VGrid);
Vue.component("v-grid-cell", VGridCell);
